/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */

/**
 * Status of the user
 */
export type UserListItemResponseDtoStatus = typeof UserListItemResponseDtoStatus[keyof typeof UserListItemResponseDtoStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserListItemResponseDtoStatus = {
  AWAITING: 'AWAITING',
  CONFIRMED: 'CONFIRMED',
  DEACTIVATED: 'DEACTIVATED',
} as const;
